/*
  Ecom Project - formulario de datos de envio previo al pago (prueba, 14-oct-2026).

  Que hace (detalle en snippets/ep-checkout.liquid y notas/CHECKOUT-PROPIO.md):
  1. Abre un <dialog> al pulsar cualquier [data-ep-checkout-abrir] ("Ir a pagar").
  2. 23-oct: una pregunta por pantalla. Primero "Envio a domicilio" o "Recojo
     en tienda". Recojo (27-oct): tiendas con stock de todo el carrito; la
     elegida llega marcada al checkout. Envio: "Lima y Callao" (direccion con
     el mapa arriba) o "Provincia" (directo a /checkout).
     El documento, solo si esta activo en Ajustes:
     "Lima y Callao" o "Provincia". El ubigeo sale de los selectores
     Departamento > Provincia > Distrito (catalogo INEI), siempre exacto.
  3. En Lima y Callao ofrece sugerencias de Google solo para guardar
     coordenadas. Google Maps se carga recien al elegir "Lima y Callao" (usa el
     que ya cargo el bloque de Cluster si esta en la pagina; si no, la clave de
     Ajustes del tema). En provincia nunca se carga. Si el cliente edita la direccion
     despues de elegir, las coordenadas se borran (no quedan datos viejos).
  4. Escribe en el carrito los MISMOS atributos que el modal de Cluster y entra
     por /checkout con la direccion precargada. El carrito no se reinicia.
  No guarda DNI ni RUC en el navegador: al reabrir, los datos se leen de los
  atributos del propio carrito. Solo la direccion y la referencia quedan en
  sessionStorage (se borran al cerrar la pestana).
*/
(function () {
  'use strict';
  if (window.__epCheckout) return;
  window.__epCheckout = true;

  var CFG = {};
  try {
    CFG = JSON.parse((document.getElementById('ep-checkout-config') || {}).textContent || '{}');
    /* Documento (DNI/CE y factura): con el ajuste encendido se pide al inicio, como
       Cluster. 26-oct: el bloque "Informacion de facturacion" del checkout (Checkout
       Blocks) se oculta cuando el carrito tiene ClusterCart-optimized, que este
       formulario guarda: con el ajuste apagado nadie pediria el DNI. */
    CFG.pedirDocumento = CFG.pedirDocumento === true;
  } catch (e) {
    CFG = {};
  }

  /* Codigos de documento: los del bloque de Cluster (catalogo SUNAT) */
  var cc = window.CLUSTER_CART_V2_CONFIG || {};
  var DOCS = {
    DNI: { codigo: String(cc.dniValue || '01'), minimo: 8, largo: 8, nombre: 'DNI' },
    /* 27-oct: C.E. de 9 hasta 12 digitos (pedido de Gonzalo) */
    CE: { codigo: String(cc.ceValue || '04'), minimo: 9, largo: 12, nombre: 'C.E.' }
  };

  /* Codigos de region de Shopify para Peru (los mismos que usa Cluster) */
  var REGION = {
    Amazonas: 'PE-AMA', Ancash: 'PE-ANC', Apurimac: 'PE-APU', Arequipa: 'PE-ARE', Ayacucho: 'PE-AYA',
    Cajamarca: 'PE-CAJ', Callao: 'PE-CAL', Cusco: 'PE-CUS', Huancavelica: 'PE-HUV', Huanuco: 'PE-HUC',
    Ica: 'PE-ICA', Junin: 'PE-JUN', 'La Libertad': 'PE-LAL', Lambayeque: 'PE-LAM', Loreto: 'PE-LOR',
    'Madre de Dios': 'PE-MDD', Moquegua: 'PE-MOQ', Pasco: 'PE-PAS', Piura: 'PE-PIU', Puno: 'PE-PUN',
    'San Martin': 'PE-SAM', Tacna: 'PE-TAC', Tumbes: 'PE-TUM', Ucayali: 'PE-UCA'
  };
  function codigoRegion(dep, prov) {
    if (dep === 'Lima') return prov === 'Lima' ? 'PE-LMA' : 'PE-LIM';
    return REGION[dep] || '';
  }

  /* Lima Metropolitana + Callao, para limitar las sugerencias de Google */
  var LIMA_BOUNDS = { north: -11.57, south: -12.52, west: -77.25, east: -76.62 };

  var SS_DIR = 'ep_co_direccion';
  var SS_REF = 'ep_co_referencia';

  /* ------------------------------------------------------------------ */
  /* Catalogo de ubigeos (assets/ep-ubigeo-pe.json)                     */
  /* { Departamento: { Provincia: [[Distrito, ubigeo], ...] } }         */
  /* ------------------------------------------------------------------ */
  var catalogo = null;
  var porUbigeo = {};
  var cargando = null;

  function cargarCatalogo() {
    if (catalogo) return Promise.resolve(catalogo);
    if (!cargando) {
      cargando = fetch(CFG.ubigeoUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          Object.keys(d).forEach(function (dep) {
            Object.keys(d[dep]).forEach(function (prov) {
              d[dep][prov].forEach(function (par) {
                porUbigeo[par[1]] = { dep: dep, prov: prov, dist: par[0], ubigeo: par[1] };
              });
            });
          });
          catalogo = d;
          return d;
        })
        .catch(function (e) {
          cargando = null;
          throw e;
        });
    }
    return cargando;
  }

  function ordenar(a, b) {
    return a.localeCompare(b, 'es');
  }

  function esLimaCallao(u) {
    return u && ((u.dep === 'Lima' && u.prov === 'Lima') || u.dep === 'Callao');
  }

  function normalizar(t) {
    return String(t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* RUC: 11 digitos, prefijo valido y digito verificador (modulo 11, SUNAT) */
  function rucValido(ruc) {
    if (!/^(10|15|16|17|20)\d{9}$/.test(ruc)) return false;
    var pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    var suma = 0;
    for (var i = 0; i < 10; i++) suma += Number(ruc[i]) * pesos[i];
    var dv = 11 - (suma % 11);
    if (dv === 10) dv = 0;
    if (dv === 11) dv = 1;
    return dv === Number(ruc[10]);
  }

  /* ------------------------------------------------------------------ */
  /* Dialogo                                                            */
  /* ------------------------------------------------------------------ */
  var dlg = null;
  var f = {}; /* campos */
  var estado = { pantalla: 'entrega', entrega: '', destino: '', tienda: null, listaTiendas: null, cerca: null, carrito: null, coords: null, dirAuto: false, sinMapa: false };

  /* 22-oct: plazos y envio gratis salen de los mismos ajustes del tema que la
     ficha ("Entrega estimada") y el carrito, para que todo diga lo mismo. */
  function plazo(r) {
    if (!r || !r[1]) return '';
    var dias = r[0] === r[1] ? String(r[1]) : r[0] + ' a ' + r[1];
    return dias + (r[1] === 1 ? ' día hábil' : ' días hábiles');
  }
  function fila(nombre, valor, icono, titulo, linea, extra) {
    return (
      '<label class="ep-co__opcion"><input type="radio" name="' + nombre + '" value="' + valor + '">' +
      '<span class="ep-co__icono">' + icono + '</span>' +
      '<span class="ep-co__op-texto"><strong>' + titulo + '</strong>' + (linea ? '<small>' + linea + '</small>' : '') + '</span>' +
      (extra || '') +
      '<span class="ep-co__flecha">' + ICONO_FLECHA + '</span></label>'
    );
  }
  function soles(centimos) {
    return 'S/. ' + (centimos / 100).toFixed(2);
  }
  var ICONO_DELIVERY = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';
  var ICONO_TIENDA = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 9.5 5 4.5h14l1.5 5M3.5 9.5h17v1a3 3 0 0 1-5.7 1.3 3 3 0 0 1-5.6 0A3 3 0 0 1 3.5 10.5zM5 13v6.5h14V13M10 19.5v-4h4v4"/></svg>';
  var ICONO_ATRAS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICONO_CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var ICONO_PIN = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.5"/></svg>';
  var ICONO_MAPA = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4.5 3.5 6.5v13l5.5-2 6 2 5.5-2v-13l-5.5 2-6-2zM9 4.5v13M15 6.5v13"/></svg>';
  var ICONO_GPS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="3.5"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"/><circle cx="12" cy="12" r="7"/></svg>';
  var ICONO_FLECHA = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
  var LIMA_CENTRO = { lat: -12.0464, lng: -77.0428 };

  /* 23-oct: hoja dentro del carrito, estilo Sifrah. Primero "Envio a domicilio"
     o "Recojo en tienda". Recojo (27-oct): lista de las tiendas con stock de
     todo el carrito; al tocar una, va al pago en "Recojo en tienda" con esa
     tienda marcada. Envio: "Lima y Callao" (direccion con mapa) o "Provincia"
     (directo al pago). Una pregunta por pantalla; lo ya elegido queda arriba. */
  function rangoCorto(r) {
    if (!r || !r[1]) return '';
    return (r[0] === r[1] ? String(r[1]) : r[0] + '–' + r[1]) + (r[1] === 1 ? ' día' : ' días');
  }
  function plantilla() {
    var plazoLima = plazo(CFG.plazos && CFG.plazos.lima);
    var plazoProv = plazo(CFG.plazos && CFG.plazos.prov);
    var cortoLima = rangoCorto(CFG.plazos && CFG.plazos.lima);
    var cortoProv = rangoCorto(CFG.plazos && CFG.plazos.prov);
    var lineaEnvio = cortoLima && cortoProv ? 'Lima ' + cortoLima + ' · Provincias ' + cortoProv : 'A tu dirección';
    return (
      '<form class="ep-co__form" novalidate>' +
      '<div class="ep-co__head">' +
      '<button type="button" class="ep-co__atras" data-ep-atras aria-label="Volver" hidden>' + ICONO_ATRAS + '</button>' +
      '<h2 class="ep-co__titulo" id="ep-co-titulo" tabindex="-1">¿Cómo quieres recibir tu pedido?</h2>' +
      '<button type="button" class="ep-co__cerrar" data-ep-cerrar aria-label="Cerrar">&times;</button>' +
      '</div>' +
      '<div class="ep-co__cuerpo" data-ep-cuerpo>' +
      '<p class="ep-co__elegido" data-ep-elegido hidden>' + ICONO_CHECK + '<span data-ep-elegido-texto></span>' +
      '<button type="button" class="ep-co__cambiar" data-ep-cambiar>Cambiar</button></p>' +

      /* Pantalla 1: como lo recibe */
      '<div class="ep-co__pantalla" data-ep-pantalla="entrega">' +
      '<p class="ep-co__sub" data-ep-resumen hidden></p>' +
      /* Documento (solo si se activa en Ajustes) */
      '<fieldset class="ep-co__grupo" data-ep-documento>' +
      '<legend class="ep-co__leyenda">Documento de identidad</legend>' +
      '<div class="ep-co__fila">' +
      '<label class="ep-co__campo">Tipo<select name="tipo"><option value="DNI">DNI</option><option value="CE">C.E.</option></select></label>' +
      '<label class="ep-co__campo">Número<input name="doc" inputmode="numeric" autocomplete="off" maxlength="12" aria-describedby="ep-co-e-doc"></label>' +
      '</div>' +
      '<p class="ep-co__error" id="ep-co-e-doc" aria-live="polite"></p>' +
      '<label class="ep-co__check"><input type="checkbox" name="factura"> Necesito factura (RUC)</label>' +
      '<div class="ep-co__grupo" data-ep-factura hidden>' +
      '<label class="ep-co__campo">RUC<input name="ruc" inputmode="numeric" autocomplete="off" maxlength="11" aria-describedby="ep-co-e-ruc"></label>' +
      '<p class="ep-co__error" id="ep-co-e-ruc" aria-live="polite"></p>' +
      '<label class="ep-co__campo">Razón social<input name="razon" autocomplete="organization" aria-describedby="ep-co-e-razon"></label>' +
      '<p class="ep-co__error" id="ep-co-e-razon" aria-live="polite"></p>' +
      '</div>' +
      '</fieldset>' +
      '<fieldset class="ep-co__grupo">' +
      '<legend class="ep-co__oculto">Cómo lo recibes</legend>' +
      '<div class="ep-co__entrega">' +
      fila('entrega', 'delivery', ICONO_DELIVERY, 'Envío a domicilio', lineaEnvio, '<span class="ep-co__sello" data-ep-gratis hidden>Gratis</span>') +
      fila('entrega', 'recojo', ICONO_TIENDA, 'Recojo en tienda', 'Elige una tienda con stock', '<span class="ep-co__sello">Gratis</span>') +
      '</div>' +
      '<p class="ep-co__error" id="ep-co-e-entrega" aria-live="polite"></p>' +
      '</fieldset>' +
      '</div>' +

      /* Pantalla 2 (recojo): tiendas con stock de todo el carrito */
      '<div class="ep-co__pantalla" data-ep-pantalla="tiendas" hidden>' +
      '<p class="ep-co__sub" data-ep-tiendas-nota aria-live="polite"></p>' +
      /* 28-oct (QA): arriba de la lista, para no tener que bajar por las 11 tiendas apagadas */
      '<button type="button" class="ep-co__cambiar ep-co__ir-envio" data-ep-ir-envio hidden>Prefiero envío a domicilio</button>' +
      /* 28-oct: ordenar por cercania (GPS solo si el cliente toca el boton) */
      '<div class="ep-co__cerca" data-ep-cerca hidden>' +
      '<button type="button" class="ep-co__cerca-btn" data-ep-cerca-btn>' + ICONO_GPS + '<span data-ep-cerca-texto>Ordenar por cercanía</span></button>' +
      '<p class="ep-co__nota" data-ep-cerca-nota aria-live="polite"></p>' +
      '</div>' +
      '<fieldset class="ep-co__grupo">' +
      '<legend class="ep-co__oculto">Tienda de recojo</legend>' +
      '<div class="ep-co__entrega ep-co__tiendas" data-ep-tiendas></div>' +
      '</fieldset>' +
      '</div>' +

      /* Pantalla 2 (envio): Lima o provincia */
      '<div class="ep-co__pantalla" data-ep-pantalla="destino" hidden>' +
      '<fieldset class="ep-co__grupo">' +
      '<legend class="ep-co__oculto">Destino</legend>' +
      '<div class="ep-co__entrega">' +
      fila('destino', 'lima', ICONO_PIN, 'Lima y Callao', plazoLima) +
      fila('destino', 'provincia', ICONO_MAPA, 'Provincia', plazoProv) +
      '</div>' +
      '<p class="ep-co__error" id="ep-co-e-destino" aria-live="polite"></p>' +
      '</fieldset>' +
      '</div>' +

      /* Pantalla 3 (Lima + envio): mapa arriba, direccion, distrito y referencia */
      '<div class="ep-co__pantalla" data-ep-pantalla="direccion" hidden>' +
      '<div class="ep-co__mapa-bloque">' +
      '<div class="ep-co__mapa" data-ep-mapa hidden>' +
      '<div class="ep-co__mapa-lienzo" data-ep-mapa-lienzo></div>' +
      '<span class="ep-co__mapa-pin" aria-hidden="true"></span>' +
      '<button type="button" class="ep-co__gps" data-ep-gps hidden>' + ICONO_GPS +
      '<span data-ep-gps-texto>Usar mi ubicación</span></button>' +
      '</div>' +
      '<p class="ep-co__mapa-ayuda" data-ep-mapa-ayuda hidden>Mueve el mapa hasta tu puerta</p>' +
      '</div>' +
      '<div class="ep-co__ubicacion" data-ep-ubicacion data-destino="lima">' +
      '<div class="ep-co__bloque">' +
      '<div class="ep-co__dir">' +
      '<label class="ep-co__campo">Dirección<input name="dir" autocomplete="address-line1" placeholder="Calle y número" aria-describedby="ep-co-e-dir ep-co-n-dir" aria-autocomplete="list" aria-controls="ep-co-sug"></label>' +
      '<ul class="ep-co__sugerencias" id="ep-co-sug" role="listbox" hidden></ul>' +
      '</div>' +
      '<p class="ep-co__error" id="ep-co-e-dir" aria-live="polite"></p>' +
      '<p class="ep-co__nota" id="ep-co-n-dir" aria-live="polite"></p></div>' +
      '<div class="ep-co__bloque">' +
      '<label class="ep-co__campo">Distrito<select name="dist" aria-describedby="ep-co-e-dist"></select></label>' +
      '<p class="ep-co__error" id="ep-co-e-dist" aria-live="polite"></p></div>' +
      '<div class="ep-co__bloque">' +
      '<label class="ep-co__campo">Referencia (opcional)<input name="ref" autocomplete="address-line2" placeholder="Ej.: portón negro"></label></div>' +
      '</div>' +
      '<p class="ep-co__error" data-ep-error-carga aria-live="polite"></p>' +
      '</div>' +

      '</div>' +
      '<div class="ep-co__pie">' +
      /* Resumen como Sifrah: productos, envio y total (en las pantallas con boton) */
      '<dl class="ep-co__totales" data-ep-totales hidden>' +
      '<div><dt data-ep-t-productos>Productos</dt><dd data-ep-t-subtotal></dd></div>' +
      '<div><dt>Envío</dt><dd data-ep-t-envio></dd></div>' +
      '<div class="ep-co__total"><dt>Total</dt><dd data-ep-t-total></dd></div>' +
      '</dl>' +
      '<button type="submit" class="button" data-ep-continuar hidden>Ir a pagar</button>' +
      '<p class="ep-co__nota ep-co__nota--ok" data-ep-directo-nota aria-live="polite" hidden></p>' +
      '<p class="ep-co__error" data-ep-error-envio aria-live="polite"></p>' +
      '</div>' +
      '</form>'
    );
  }

  function crearDialogo() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ep-co ' + (CFG.esquema || '');
    dlg.setAttribute('aria-labelledby', 'ep-co-titulo');
    dlg.innerHTML = plantilla();
    document.body.appendChild(dlg);

    var form = dlg.querySelector('form');
    ['tipo', 'doc', 'factura', 'ruc', 'razon', 'dist', 'dir', 'ref'].forEach(function (n) {
      f[n] = form.elements[n];
    });
    f.destino = form.querySelectorAll('input[name="destino"]');
    f.entrega = form.querySelectorAll('input[name="entrega"]');
    f.directoNota = dlg.querySelector('[data-ep-directo-nota]');
    f.titulo = dlg.querySelector('#ep-co-titulo');
    f.cuerpo = dlg.querySelector('[data-ep-cuerpo]');
    f.atras = dlg.querySelector('[data-ep-atras]');
    f.elegido = dlg.querySelector('[data-ep-elegido]');
    f.elegidoTexto = dlg.querySelector('[data-ep-elegido-texto]');
    f.atras.addEventListener('click', function () {
      mostrarPantalla(estado.pantalla === 'direccion' ? 'destino' : 'entrega');
    });
    dlg.querySelector('[data-ep-cambiar]').addEventListener('click', function () {
      mostrarPantalla('entrega');
    });
    Array.prototype.forEach.call(f.entrega, function (r) {
      r.addEventListener('change', function () {
        if (r.checked) elegirEntrega(r.value);
      });
      /* tocar otra vez la opcion ya elegida (al volver) tambien avanza */
      r.addEventListener('click', function () {
        if (estado.entrega !== r.value) return;
        if (!documentoListo()) return;
        if (r.value === 'delivery') mostrarPantalla('destino');
        else verTiendas();
      });
    });
    f.tiendas = dlg.querySelector('[data-ep-tiendas]');
    f.tiendasNota = dlg.querySelector('[data-ep-tiendas-nota]');
    f.irEnvio = dlg.querySelector('[data-ep-ir-envio]');
    /* 27-oct: tocar una tienda con stock va directo al pago con esa tienda */
    f.tiendas.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="tienda"]');
      if (!r || !r.checked || r.disabled) return;
      estado.tienda = { id: r.value, nombre: r.getAttribute('data-nombre') };
      irDirecto('recojo');
    });
    /* tocar otra vez la tienda ya elegida (al volver del pago) tambien avanza */
    f.tiendas.addEventListener('click', function (e) {
      var r = e.target.closest('input[name="tienda"]');
      if (!r || r.disabled || !estado.tienda || estado.tienda.id !== r.value) return;
      irDirecto('recojo');
    });
    f.irEnvio.addEventListener('click', function () {
      dlg.querySelector('input[name="entrega"][value="delivery"]').checked = true;
      mostrarPantalla('entrega');
      elegirEntrega('delivery');
    });
    f.cerca = dlg.querySelector('[data-ep-cerca]');
    f.cercaBtn = dlg.querySelector('[data-ep-cerca-btn]');
    f.cercaTexto = dlg.querySelector('[data-ep-cerca-texto]');
    f.cercaNota = dlg.querySelector('[data-ep-cerca-nota]');
    f.cercaBtn.addEventListener('click', ordenarPorCercania);
    Array.prototype.forEach.call(f.destino, function (r) {
      r.addEventListener('change', function () {
        if (r.checked) elegirDestino(r.value);
      });
      r.addEventListener('click', function () {
        if (estado.destino !== r.value) return;
        if (r.value === 'lima') prepararDireccion();
        else irDirecto('provincia');
      });
    });
    f.ubicacion = dlg.querySelector('[data-ep-ubicacion]');
    f.facturaBox = dlg.querySelector('[data-ep-factura]');
    f.sug = dlg.querySelector('#ep-co-sug');
    f.notaDir = dlg.querySelector('#ep-co-n-dir');
    f.mapa = dlg.querySelector('[data-ep-mapa]');
    f.gps = dlg.querySelector('[data-ep-gps]');
    f.gpsTexto = dlg.querySelector('[data-ep-gps-texto]');
    f.documento = dlg.querySelector('[data-ep-documento]');
    if (!CFG.pedirDocumento) f.documento.hidden = true;
    f.gps.addEventListener('click', usarUbicacion);
    f.lienzo = dlg.querySelector('[data-ep-mapa-lienzo]');
    f.mapaAyuda = dlg.querySelector('[data-ep-mapa-ayuda]');
    f.btn = dlg.querySelector('[data-ep-continuar]');
    f.errCarga = dlg.querySelector('[data-ep-error-carga]');
    f.errEnvio = dlg.querySelector('[data-ep-error-envio]');

    dlg.querySelector('[data-ep-cerrar]').addEventListener('click', cerrar);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) cerrar(); /* clic en el fondo */
    });
    dlg.addEventListener('close', ocultarSugerencias);

    f.doc.addEventListener('input', function () {
      f.doc.value = f.doc.value.replace(/\D/g, '').slice(0, DOCS[f.tipo.value].largo);
      limpiarError('doc');
    });
    f.tipo.addEventListener('change', function () {
      f.doc.maxLength = DOCS[f.tipo.value].largo;
      f.doc.value = f.doc.value.slice(0, DOCS[f.tipo.value].largo);
      limpiarError('doc');
    });
    f.factura.addEventListener('change', function () {
      f.facturaBox.hidden = !f.factura.checked;
    });
    f.ruc.addEventListener('input', function () {
      f.ruc.value = f.ruc.value.replace(/\D/g, '').slice(0, 11);
      limpiarError('ruc');
    });
    f.razon.addEventListener('input', function () {
      limpiarError('razon');
    });
    f.dist.addEventListener('change', function () {
      limpiarError('dist');
      /* si cambia el distrito, las coordenadas de una sugerencia ya no valen;
         un pin puesto por el cliente (a mano o con su ubicacion) se respeta */
      if (estado.coords && estado.coords.ajustado) return;
      borrarCoordenadas();
      centrarEnDistrito();
    });
    f.dir.addEventListener('input', function () {
      limpiarError('dir');
      estado.dirAuto = false;
      /* las coordenadas de Google se borran si cambia el texto; un pin movido a mano se respeta */
      if (estado.coords && !estado.coords.ajustado && f.dir.value !== estado.coords.texto) borrarCoordenadas();
      programarSugerencias();
    });
    f.dir.addEventListener('keydown', teclasSugerencias);
    /* 27-oct: pin obligatorio en Lima. Al terminar de escribir (o al cambiar
       el distrito), si no hay pin, se ubica la direccion en el mapa. La espera
       deja pasar primero una sugerencia elegida con el mouse. */
    f.dir.addEventListener('change', function () {
      setTimeout(function () {
        if (!estado.coords) ubicarDireccion();
      }, 250);
    });
    f.dist.addEventListener('change', function () {
      setTimeout(function () {
        if (!estado.coords && f.dir.value.trim().length >= 5) ubicarDireccion();
      }, 300);
    });
    form.addEventListener('submit', enviar);
    return dlg;
  }

  function error(campo, texto) {
    var p = dlg.querySelector('#ep-co-e-' + campo);
    if (p) p.textContent = texto;
    var el = f[campo];
    if (el && el.setAttribute) el.setAttribute('aria-invalid', 'true');
  }
  function limpiarError(campo) {
    var p = dlg.querySelector('#ep-co-e-' + campo);
    if (p) p.textContent = '';
    var el = f[campo];
    if (el && el.removeAttribute) el.removeAttribute('aria-invalid');
  }

  /* ------------------------------------------------------------------ */
  /* Destino y selectores                                               */
  /* ------------------------------------------------------------------ */
  function opcion(valor, texto) {
    var o = document.createElement('option');
    o.value = valor;
    o.textContent = texto;
    return o;
  }

  /* Envio: pasa a "Lima o provincia". Recojo: pasa a la lista de tiendas con stock. */
  function elegirEntrega(entrega) {
    /* 26-oct: el documento va al inicio (como Cluster); sin documento valido no avanza */
    if (!documentoListo()) {
      Array.prototype.forEach.call(f.entrega, function (r) {
        r.checked = false;
      });
      estado.entrega = '';
      return;
    }
    estado.entrega = entrega;
    limpiarError('entrega');
    f.errEnvio.textContent = '';
    if (entrega === 'recojo') {
      ocultarSugerencias();
      ocultarMapa();
      /* el stock se pide ya; la pantalla cambia tras la animacion de la fila */
      setTimeout(function () {
        if (estado.pantalla === 'entrega' && estado.entrega === 'recojo') verTiendas();
      }, 180);
      return;
    }
    /* Google Maps se va pidiendo por si elige Lima (mapa y sugerencias rapidos) */
    googleListo().catch(function () {});
    setTimeout(function () {
      if (estado.pantalla === 'entrega' && estado.entrega === entrega) mostrarPantalla('destino');
    }, 180);
  }

  /* ------------------------------------------------------------------ */
  /* 27-oct: tiendas de recojo con stock de todo el carrito             */
  /* ------------------------------------------------------------------ */
  /* La API de Storefront (sin token) dice, por tienda con recojo, si cada
     variante esta disponible (storeAvailability.available). Son las mismas
     tiendas del selector del checkout. Sin token no da la cantidad: con 2 o
     mas unidades del mismo producto, el checkout es el que confirma si alcanza.
     La consulta se guarda mientras el carrito no cambie. */
  var tiendasPedido = null;
  var tiendasClave = '';
  var turnoTiendas = 0;

  function lineasConEnvio(cart) {
    return ((cart && cart.items) || []).filter(function (i) {
      return i.requires_shipping !== false;
    });
  }

  function nombreTienda(n) {
    return String(n || '')
      .replace(/^LAB NUTRITION\s*\|\s*/i, '')
      .split(' ')
      .map(function (p) {
        return /\d/.test(p) ? p : p.charAt(0) + p.slice(1).toLowerCase();
      })
      .join(' ');
  }

  function pedirTiendas(cart) {
    var lineas = lineasConEnvio(cart);
    var clave = lineas
      .map(function (i) {
        return i.variant_id + 'x' + i.quantity;
      })
      .join(',');
    if (tiendasPedido && clave === tiendasClave) return tiendasPedido;
    tiendasClave = clave;
    var ids = [];
    lineas.forEach(function (i) {
      var gid = 'gid://shopify/ProductVariant/' + i.variant_id;
      if (ids.indexOf(gid) === -1) ids.push(gid);
    });
    var p = !ids.length
      ? Promise.reject(new Error('sin productos'))
      : fetch('/api/2025-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            query:
              'query EpTiendas($ids: [ID!]!) { nodes(ids: $ids) { ... on ProductVariant { id storeAvailability(first: 50) { nodes { available pickUpTime location { id name address { address1 city latitude longitude } } } } } } }',
            variables: { ids: ids }
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (d) {
            var variantes = ((d && d.data && d.data.nodes) || []).filter(function (v) {
              return v && v.storeAvailability;
            });
            if ((d && d.errors) || variantes.length !== ids.length) throw new Error('respuesta incompleta');
            var porTienda = {};
            variantes.forEach(function (v) {
              v.storeAvailability.nodes.forEach(function (s) {
                var id = String(s.location.id);
                var dir = s.location.address || {};
                var t =
                  porTienda[id] ||
                  (porTienda[id] = {
                    id: id.split('/').pop(),
                    nombre: nombreTienda(s.location.name),
                    direccion: [dir.address1, dir.city].filter(Boolean).join(', '),
                    lat: dir.latitude == null ? null : Number(dir.latitude),
                    lng: dir.longitude == null ? null : Number(dir.longitude),
                    conStock: 0,
                    listo: ''
                  });
                if (s.available) {
                  t.conStock++;
                  if (!t.listo) t.listo = s.pickUpTime || '';
                }
              });
            });
            return Object.keys(porTienda)
              .map(function (k) {
                var t = porTienda[k];
                t.faltan = variantes.length - t.conStock;
                return t;
              })
              .sort(function (a, b) {
                return (a.faltan > 0) - (b.faltan > 0) || a.nombre.localeCompare(b.nombre, 'es');
              });
          });
    tiendasPedido = p;
    p.catch(function () {
      if (tiendasPedido === p) tiendasPedido = null;
    });
    return p;
  }

  /* Muestra la pantalla de tiendas y la llena con el stock del carrito actual */
  function verTiendas() {
    mostrarPantalla('tiendas');
    pintarTiendas(null);
    var turno = ++turnoTiendas;
    var pedido = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        estado.carrito = cart;
        origenCercania(cart);
        return pedirTiendas(cart);
      });
    var espera = new Promise(function (ok, falla) {
      setTimeout(function () {
        falla(new Error('tiempo'));
      }, 8000);
    });
    Promise.race([pedido, espera]).then(
      function (lista) {
        if (turno === turnoTiendas) pintarTiendas(lista);
      },
      function () {
        if (turno === turnoTiendas) pintarTiendas(false);
      }
    );
  }

  /* 28-oct: orden por cercania. El punto de partida es la ubicacion del GPS
     (solo si el cliente toca "Ordenar por cercania") o, si ya marco su pin de
     Lima en esta compra, esa direccion. Queda solo en memoria: no se guarda en
     el carrito ni en el navegador. Distancia en linea recta. */
  function origenCercania(cart) {
    if (estado.cerca && estado.cerca.origen === 'gps') return;
    var a = (cart && cart.attributes) || {};
    var c = estado.coords || { lat: parseFloat(a['ClusterCart-latitude']), lng: parseFloat(a['ClusterCart-longitude']) };
    estado.cerca = isFinite(c.lat) && isFinite(c.lng) ? { lat: c.lat, lng: c.lng, origen: 'direccion' } : null;
  }

  function distanciaKm(a, b) {
    var rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad;
    var dLng = (b.lng - a.lng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 12742 * Math.asin(Math.sqrt(h));
  }

  function textoDistancia(km) {
    if (km < 1) return Math.max(100, Math.round(km * 10) * 100) + ' m';
    if (km < 10) return km.toFixed(1).replace('.', ',') + ' km';
    return Math.round(km) + ' km';
  }

  function ordenarPorCercania() {
    if (!navigator.geolocation || f.cercaBtn.getAttribute('aria-busy') === 'true') return;
    f.cercaBtn.setAttribute('aria-busy', 'true');
    f.cercaTexto.textContent = 'Buscando tu ubicación…';
    f.cercaNota.textContent = '';
    function listo() {
      f.cercaBtn.removeAttribute('aria-busy');
      f.cercaTexto.textContent = 'Ordenar por cercanía';
    }
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        listo();
        estado.cerca = { lat: pos.coords.latitude, lng: pos.coords.longitude, origen: 'gps' };
        if (estado.pantalla === 'tiendas' && estado.listaTiendas) pintarTiendas(estado.listaTiendas);
      },
      function () {
        listo();
        f.cercaNota.textContent = 'No pudimos ver tu ubicación. Revisa el permiso de ubicación del navegador; la lista sigue por nombre.';
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  }

  /* null: cargando · false: no se pudo ver el stock (se elige en el pago) · lista */
  function pintarTiendas(lista) {
    f.tiendas.textContent = '';
    f.tiendasNota.hidden = false;
    f.irEnvio.hidden = true;
    f.cerca.hidden = true;
    f.btn.hidden = true;
    if (lista === null) {
      f.tiendasNota.textContent = 'Revisando el stock de las tiendas…';
      return;
    }
    if (!lista || !lista.length) {
      f.tiendasNota.textContent = 'No pudimos revisar el stock de las tiendas. Puedes elegir la tienda en el pago.';
      estado.tienda = null;
      f.btn.hidden = false;
      f.btn.textContent = 'Ir a pagar';
      return;
    }
    estado.listaTiendas = lista;
    /* con stock primero; dentro, por cercania si hay punto de partida, si no por nombre */
    var cerca = estado.cerca;
    lista = lista
      .map(function (t) {
        t.km = cerca && t.lat != null && t.lng != null && !t.faltan ? distanciaKm(cerca, t) : null;
        return t;
      })
      .sort(function (a, b) {
        return (
          (a.faltan > 0) - (b.faltan > 0) ||
          (a.km == null) - (b.km == null) ||
          (a.km != null && b.km != null ? a.km - b.km : 0) ||
          a.nombre.localeCompare(b.nombre, 'es')
        );
      });
    var conStock = lista.filter(function (t) {
      return !t.faltan;
    });
    var total = lista[0].conStock + lista[0].faltan;
    if (conStock.length) {
      f.tiendasNota.textContent = conStock[0].listo ? conStock[0].listo + '.' : '';
      f.tiendasNota.hidden = !conStock[0].listo;
      /* el orden importa solo con 2 o mas tiendas para elegir */
      if (conStock.length > 1 && (cerca || navigator.geolocation)) {
        f.cerca.hidden = false;
        f.cercaBtn.hidden = !!cerca;
        f.cercaNota.textContent = cerca
          ? cerca.origen === 'gps'
            ? 'Ordenadas por cercanía a tu ubicación.'
            : 'Ordenadas por cercanía a tu dirección.'
          : '';
      }
    } else {
      f.tiendasNota.textContent =
        total === 1 ? 'Tu producto no tiene stock en ninguna tienda ahora.' : 'Ninguna tienda tiene todos tus productos ahora.';
      f.irEnvio.hidden = false;
    }
    lista.forEach(function (t, i) {
      if (t.faltan && (i === 0 || !lista[i - 1].faltan)) {
        var h = document.createElement('p');
        h.className = 'ep-co__tiendas-titulo';
        h.textContent = total === 1 ? 'Sin stock' : 'Sin stock de todos tus productos';
        f.tiendas.appendChild(h);
      }
      var l = document.createElement('label');
      l.className = 'ep-co__opcion';
      l.innerHTML =
        '<input type="radio" name="tienda"><span class="ep-co__op-texto"><strong></strong><small></small></span>' +
        (t.km != null ? '<span class="ep-co__km">' + textoDistancia(t.km) + '</span>' : '') +
        (t.faltan ? '' : '<span class="ep-co__flecha">' + ICONO_FLECHA + '</span>');
      var r = l.querySelector('input');
      r.value = t.id;
      r.setAttribute('data-nombre', t.nombre);
      r.disabled = t.faltan > 0;
      if (!r.disabled && estado.tienda && estado.tienda.id === t.id) r.checked = true;
      l.querySelector('strong').textContent = t.nombre;
      l.querySelector('small').textContent = !t.faltan || total === 1
        ? t.direccion
        : t.faltan === total
          ? 'Sin stock de tus productos'
          : t.faltan === 1
            ? 'Falta 1 de tus productos'
            : 'Faltan ' + t.faltan + ' de tus ' + total + ' productos';
      f.tiendas.appendChild(l);
    });
  }

  /* Provincia: directo al pago (la direccion se llena en el checkout). Lima: direccion con mapa. */
  function elegirDestino(destino) {
    estado.destino = destino;
    limpiarError('destino');
    f.errEnvio.textContent = '';
    if (destino === 'provincia') {
      ocultarSugerencias();
      ocultarMapa();
      irDirecto('provincia');
      return;
    }
    setTimeout(function () {
      if (estado.pantalla === 'destino' && estado.destino === 'lima') prepararDireccion();
    }, 180);
  }

  /* Pantalla de direccion (Lima + delivery): distritos de Lima y Callao y el
     mapa en el pin ya marcado, en el distrito o en Lima completa. */
  function prepararDireccion(ubigeo) {
    f.errCarga.textContent = '';
    if (f.gps) f.gps.hidden = !navigator.geolocation;
    mostrarPantalla('direccion');
    return cargarCatalogo()
      .then(function () {
        if (f.dist.options.length <= 1) llenarDistritosLima();
        if (ubigeo) f.dist.value = ubigeo;
        if (estado.coords) mostrarMapa(estado.coords.lat, estado.coords.lng, 17);
        else centrarEnDistrito();
      })
      .catch(function () {
        f.errCarga.textContent = 'No cargaron los distritos. Revisa tu conexión y vuelve a intentar.';
      });
  }

  /* Muestra una pantalla y ajusta titulo, "volver", lo ya elegido, el boton y el resumen */
  function mostrarPantalla(nombre) {
    estado.pantalla = nombre;
    dlg.querySelectorAll('[data-ep-pantalla]').forEach(function (p) {
      p.hidden = p.getAttribute('data-ep-pantalla') !== nombre;
    });
    f.titulo.textContent =
      nombre === 'destino'
        ? '¿A dónde lo enviamos?'
        : nombre === 'direccion'
          ? '¿Dónde te lo dejamos?'
          : nombre === 'tiendas'
            ? '¿En qué tienda lo recoges?'
            : '¿Cómo quieres recibir tu pedido?';
    f.atras.hidden = nombre === 'entrega';
    var partes = [];
    if (nombre === 'tiendas') partes.push('Recojo en tienda');
    if (nombre === 'destino') partes.push('Envío a domicilio');
    if (nombre === 'direccion') partes.push('Envío', 'Lima y Callao');
    f.elegido.hidden = !partes.length;
    f.elegidoTexto.textContent = partes.join(' · ');
    var conBoton = nombre === 'direccion';
    f.btn.hidden = !conBoton;
    f.btn.textContent = 'Ir a pagar';
    pintarTotales(conBoton);
    ocultarSugerencias();
    f.cuerpo.scrollTop = 0;
    if (dlg.open) f.titulo.focus({ preventScroll: true });
  }

  /* Productos, envio y total, como en Sifrah. El envio es gratis en recojo o si
     el carrito llega al monto de envio gratis; si no, se calcula en el pago. */
  function pintarTotales(ver) {
    var caja = dlg.querySelector('[data-ep-totales]');
    var cart = estado.carrito;
    if (!ver || !cart || !cart.item_count) {
      caja.hidden = true;
      return;
    }
    var umbral = Number(CFG.umbral) * 100;
    var gratis = estado.entrega === 'recojo' || (umbral > 0 && cart.total_price >= umbral);
    dlg.querySelector('[data-ep-t-productos]').textContent = 'Productos (' + cart.item_count + ')';
    dlg.querySelector('[data-ep-t-subtotal]').textContent = soles(cart.total_price);
    dlg.querySelector('[data-ep-t-envio]').textContent = gratis ? 'Gratis' : 'Se calcula en el pago';
    dlg.querySelector('[data-ep-t-total]').textContent = gratis ? soles(cart.total_price) : soles(cart.total_price) + ' + envío';
    caja.hidden = false;
  }

  function llenarDistritosLima() {
    f.dist.replaceChildren(opcion('', 'Elige tu distrito'));
    [
      ['Lima', 'Lima', 'Lima'],
      ['Callao', 'Callao', 'Callao']
    ].forEach(function (g) {
      var grupo = document.createElement('optgroup');
      grupo.label = g[2];
      catalogo[g[0]][g[1]]
        .slice()
        .sort(function (a, b) {
          return ordenar(a[0], b[0]);
        })
        .forEach(function (par) {
          grupo.appendChild(opcion(par[1], par[0]));
        });
      f.dist.appendChild(grupo);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Google (solo Lima y Callao, solo para coordenadas)                 */
  /* ------------------------------------------------------------------ */
  var places = null;
  var tokenSesion = null;
  var temporizador = null;
  var consulta = 0;
  var sugerencias = [];
  var activa = -1;

  var cargaGoogle = null;
  function googleListo() {
    if (window.google && google.maps && google.maps.importLibrary) return Promise.resolve();
    if (!CFG.mapsKey) return Promise.reject(new Error('Google Maps no disponible'));
    /* una sola carga aunque se pida al elegir Lima y otra vez al escribir */
    if (cargaGoogle) return cargaGoogle;
    cargaGoogle = new Promise(function (ok, falla) {
      window.__epMapsListo = ok;
      var s = document.createElement('script');
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(CFG.mapsKey) +
        '&v=weekly&loading=async&language=es&region=PE&callback=__epMapsListo';
      s.async = true;
      s.onerror = function (e) {
        cargaGoogle = null;
        falla(e);
      };
      document.head.appendChild(s);
    });
    return cargaGoogle;
  }

  function programarSugerencias() {
    clearTimeout(temporizador);
    if (estado.destino !== 'lima') return ocultarSugerencias();
    temporizador = setTimeout(pedirSugerencias, 300);
  }

  function pedirSugerencias() {
    var texto = f.dir.value.trim();
    var u = porUbigeo[f.dist.value];
    if (texto.length < 4) return ocultarSugerencias();
    var n = ++consulta;
    googleListo()
      .then(function () {
        return places || google.maps.importLibrary('places');
      })
      .then(function (lib) {
        places = lib;
        if (!tokenSesion) tokenSesion = new places.AutocompleteSessionToken();
        return places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: u ? texto + ', ' + u.dist : texto,
          sessionToken: tokenSesion,
          includedRegionCodes: ['pe'],
          locationRestriction: LIMA_BOUNDS,
          language: 'es',
          region: 'pe'
        });
      })
      .then(function (r) {
        if (n !== consulta) return;
        sugerencias = (r.suggestions || [])
          .filter(function (s) {
            return s.placePrediction;
          })
          .slice(0, 5);
        pintarSugerencias();
      })
      .catch(ocultarSugerencias);
  }

  function pintarSugerencias() {
    activa = -1;
    if (!sugerencias.length) return ocultarSugerencias();
    f.sug.replaceChildren();
    sugerencias.forEach(function (s, i) {
      var p = s.placePrediction;
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = 'ep-co-sug-' + i;
      li.textContent = p.mainText ? p.mainText.text : p.text.text;
      if (p.secondaryText) {
        var sm = document.createElement('small');
        sm.textContent = p.secondaryText.text;
        li.appendChild(sm);
      }
      /* mousedown para que gane al blur del input */
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        elegirSugerencia(i);
      });
      /* respaldo para Safari de iPhone si el toque no llega como mousedown */
      li.addEventListener('click', function () {
        if (!f.sug.hidden) elegirSugerencia(i);
      });
      f.sug.appendChild(li);
    });
    f.sug.hidden = false;
    f.dir.setAttribute('aria-expanded', 'true');
    /* que la lista se vea entera aunque el teclado del movil ocupe media pantalla */
    f.sug.scrollIntoView({ block: 'nearest' });
  }

  function ocultarSugerencias() {
    if (!f.sug) return;
    f.sug.hidden = true;
    f.dir.setAttribute('aria-expanded', 'false');
    f.dir.removeAttribute('aria-activedescendant');
  }

  function teclasSugerencias(e) {
    if (f.sug.hidden) return;
    var items = f.sug.querySelectorAll('li');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      activa = (activa + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items.forEach(function (li, i) {
        li.setAttribute('aria-selected', String(i === activa));
      });
      f.dir.setAttribute('aria-activedescendant', 'ep-co-sug-' + activa);
    } else if (e.key === 'Enter' && activa >= 0) {
      e.preventDefault();
      elegirSugerencia(activa);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      ocultarSugerencias();
    }
  }

  function elegirSugerencia(i) {
    var pred = sugerencias[i] && sugerencias[i].placePrediction;
    ocultarSugerencias();
    if (!pred) return;
    var principal = pred.mainText ? pred.mainText.text : '';
    /* Se respeta lo que escribio el cliente (dpto., interior...); solo se
       toma el texto de Google si el cliente no puso numero y Google si. */
    if (principal && !/\d/.test(f.dir.value) && /\d/.test(principal)) f.dir.value = principal;
    var place = pred.toPlace();
    place
      .fetchFields({ fields: ['location', 'formattedAddress', 'addressComponents'] })
      .then(function () {
        tokenSesion = null;
        if (!place.location) return;
        estado.coords = { lat: place.location.lat(), lng: place.location.lng(), texto: f.dir.value };
        /* 22-oct: el distrito sale de la direccion elegida (se puede cambiar) */
        var elegido = distritoDeComponentes([
          (place.addressComponents || []).map(function (c) {
            return { types: c.types || [], long_name: c.longText || c.long_name || '' };
          })
        ]);
        if (elegido && f.dist.value !== elegido) {
          f.dist.value = elegido;
          limpiarError('dist');
        }
        var u = porUbigeo[f.dist.value];
        var dentro = !u || u.dist === 'Lima' || normalizar(place.formattedAddress).indexOf(normalizar(u.dist)) !== -1;
        f.notaDir.className = 'ep-co__nota' + (dentro ? ' ep-co__nota--ok' : '');
        f.notaDir.textContent = dentro
          ? '✓ Dirección ubicada'
          : 'Parece estar fuera de ' + u.dist + '. Revisa el distrito.';
        mostrarMapa(estado.coords.lat, estado.coords.lng, 17);
      })
      .catch(function () {
        estado.coords = null;
      });
  }

  /* Distrito de Lima o Callao cuyo nombre coincide con alguno de la lista */
  /* 27-oct: respeta el orden de los nombres (el primero que exista en la
     lista gana). Antes ganaba el primero de la lista de distritos, y como
     "Lima" va antes que "Miraflores", un punto de Miraflores quedaba en Lima. */
  function distritoPorNombres(nombres) {
    for (var i = 0; i < nombres.length; i++) {
      var buscado = normalizar(nombres[i]);
      for (var j = 0; j < f.dist.options.length; j++) {
        var o = f.dist.options[j];
        if (o.value && normalizar(o.textContent) === buscado) return o.value;
      }
    }
    return null;
  }

  /* Distrito a partir de los componentes de Google: primero el mas especifico.
     "Lima" solo si no hay otro, porque Google tambien llama asi a la ciudad. */
  function nombresDeDistrito(comps) {
    var nombres = [];
    ['sublocality_level_1', 'sublocality', 'administrative_area_level_3', 'locality'].forEach(function (t) {
      comps.forEach(function (c) {
        if (c.types.indexOf(t) !== -1 && nombres.indexOf(c.long_name) === -1) nombres.push(c.long_name);
      });
    });
    return nombres;
  }
  /* Recibe una o varias listas de componentes (resultados de Google, del mas
     util al menos util). Primero busca un distrito que no sea "Lima" en todas;
     "Lima" (Cercado) solo si ninguna trae otro. */
  function distritoDeComponentes(listas) {
    var i, elegido;
    for (i = 0; i < listas.length; i++) {
      elegido = distritoPorNombres(nombresDeDistrito(listas[i]).filter(function (n) {
        return normalizar(n) !== 'lima';
      }));
      if (elegido) return elegido;
    }
    for (i = 0; i < listas.length; i++) {
      elegido = distritoPorNombres(nombresDeDistrito(listas[i]));
      if (elegido) return elegido;
    }
    return null;
  }

  /* 21-oct: mapa con pin, solo en Lima y Callao. Aparece al elegir el
     distrito (centrado en el distrito) y salta a la direccion si el cliente
     elige una sugerencia. El pin queda fijo en el centro y el cliente mueve
     el mapa (como en las apps de delivery). Coordenadas: solo se guardan si
     eligio una sugerencia o movio el mapa; el centro del distrito solo no
     cuenta. Usa el mismo Google Maps que las sugerencias. Si falla, el
     formulario sigue sin mapa. */
  var mapa = null;
  var centroProgramado = null;
  /* 26-oct: el zoom automatico ya no pelea con el del cliente (ver idle) */
  var zoomEsperado = null;
  var zoomDelCliente = false;
  var arrastre = false;
  function ponerZoom(z) {
    zoomEsperado = z;
    mapa.setZoom(z);
  }
  var centrosDistrito = {};
  function mostrarMapa(lat, lng, zoom) {
    if (estado.destino !== 'lima') return;
    f.mapa.hidden = false;
    f.mapaAyuda.hidden = false;
    centroProgramado = { lat: lat, lng: lng };
    googleListo()
      .then(function () {
        return google.maps.importLibrary('maps');
      })
      .then(function (lib) {
        if (estado.destino !== 'lima') return;
        if (!mapa) {
          zoomEsperado = zoom || 17;
          mapa = new lib.Map(f.lienzo, {
            center: centroProgramado,
            zoom: zoom || 17,
            disableDefaultUI: true,
            zoomControl: true,
            gestureHandling: 'greedy',
            clickableIcons: false
          });
          /* zoom con los dedos, la rueda o los botones: es del cliente */
          mapa.addListener('zoom_changed', function () {
            if (mapa.getZoom() !== zoomEsperado) zoomDelCliente = true;
          });
          mapa.addListener('dragstart', function () {
            arrastre = true;
          });
          mapa.addListener('idle', function () {
            f.mapa.setAttribute('data-zoom', mapa.getZoom());
            var arrastro = arrastre;
            arrastre = false;
            if (estado.destino !== 'lima' || !centroProgramado) return;
            var c = mapa.getCenter();
            /* el idle de la carga o de setCenter no es un ajuste del cliente */
            if (Math.abs(c.lat() - centroProgramado.lat) < 1e-6 && Math.abs(c.lng() - centroProgramado.lng) < 1e-6) return;
            centroProgramado = { lat: c.lat(), lng: c.lng() };
            /* 23-oct: soltar el mapa, a cualquier zoom, completa distrito y
               direccion de ese punto. Si estaba lejos, se acerca solo a nivel de
               calle (el centro no cambia) para que el cliente afine el pin.
               26-oct: solo despues de arrastrar y si el cliente no uso el zoom;
               antes, alejar con los dedos o la rueda lo volvia a acercar solo. */
            if (arrastro && !zoomDelCliente && mapa.getZoom() < 16) ponerZoom(16);
            estado.coords = { lat: c.lat(), lng: c.lng(), texto: f.dir.value, ajustado: true };
            limpiarError('dir');
            f.notaDir.className = 'ep-co__nota ep-co__nota--ok';
            f.notaDir.textContent = '✓ Puerta marcada';
            /* 27-oct: si el cliente arrastro el mapa, la direccion sigue al pin */
            completarDesdeUbicacion(c.lat(), c.lng(), true, arrastro);
          });
        } else {
          mapa.setCenter(centroProgramado);
          ponerZoom(zoom || 17);
        }
      })
      .catch(ocultarMapa);
  }

  function ocultarMapa() {
    centroProgramado = null;
    if (!f.mapa) return;
    f.mapa.hidden = true;
    f.mapaAyuda.hidden = true;
  }

  /* Centra el mapa en el distrito elegido (Lima y Callao) */
  function centrarEnDistrito() {
    if (estado.destino !== 'lima') return ocultarMapa();
    var ubigeo = f.dist.value;
    var u = porUbigeo[ubigeo];
    if (!u) return estado.coords ? null : mostrarMapa(LIMA_CENTRO.lat, LIMA_CENTRO.lng, 11);
    if (centrosDistrito[ubigeo]) return mostrarMapa(centrosDistrito[ubigeo].lat, centrosDistrito[ubigeo].lng, 15);
    googleListo()
      .then(function () {
        return places || google.maps.importLibrary('places');
      })
      .then(function (lib) {
        places = lib;
        return places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: u.dist + ', ' + (u.prov === 'Callao' ? 'Callao' : 'Lima') + ', Perú',
          includedRegionCodes: ['pe'],
          locationRestriction: LIMA_BOUNDS,
          language: 'es',
          region: 'pe'
        });
      })
      .then(function (r) {
        var p = (r.suggestions || []).filter(function (x) { return x.placePrediction; })[0];
        if (!p) throw new Error('sin distrito');
        var lugar = p.placePrediction.toPlace();
        return lugar.fetchFields({ fields: ['location'] }).then(function () { return lugar; });
      })
      .then(function (lugar) {
        if (f.dist.value !== ubigeo || estado.destino !== 'lima') return;
        centrosDistrito[ubigeo] = { lat: lugar.location.lat(), lng: lugar.location.lng() };
        /* si mientras tanto eligio una sugerencia, no se pisa esa ubicacion */
        if (!estado.coords) mostrarMapa(centrosDistrito[ubigeo].lat, centrosDistrito[ubigeo].lng, 15);
      })
      .catch(function () {});
  }

  /* 21-oct: "Usar mi ubicacion" (solo Lima y Callao). Toma la ubicacion del
     celular, centra el mapa ahi y guarda las coordenadas como pin del cliente.
     Si Google lo permite (Geocoding), completa el distrito y la direccion. */
  function usarUbicacion() {
    if (!navigator.geolocation) return;
    f.gps.disabled = true;
    f.gpsTexto.textContent = 'Buscando…';
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        f.gps.disabled = false;
        f.gpsTexto.textContent = 'Usar mi ubicación';
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;
        var b = LIMA_BOUNDS;
        if (lat > b.north || lat < b.south || lng < b.west || lng > b.east) {
          f.notaDir.className = 'ep-co__nota';
          f.notaDir.textContent = 'Estás fuera de Lima y Callao. Vuelve y elige Provincia.';
          return;
        }
        estado.coords = { lat: lat, lng: lng, texto: f.dir.value, ajustado: true, gps: true };
        mostrarMapa(lat, lng, 18);
        f.notaDir.className = 'ep-co__nota ep-co__nota--ok';
        f.notaDir.textContent = '✓ Ubicación lista';
        completarDesdeUbicacion(lat, lng, true, true);
      },
      function () {
        f.gps.disabled = false;
        f.gpsTexto.textContent = 'Usar mi ubicación';
        f.notaDir.className = 'ep-co__nota';
        f.notaDir.textContent = 'No pudimos ubicarte. Escribe tu dirección.';
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }
    );
  }

  /* Distrito (y direccion, si conDireccion) a partir de un punto: la ubicacion
     del celular o el centro del mapa movido por el cliente. Usa Google
     Geocoding; si la clave no lo permite, el cliente completa a mano.
     La direccion se llena si esta vacia o si la puso el mapa antes. 27-oct:
     si el cliente movio el pin (arrastrar o "Usar mi ubicacion"), siempre se
     reemplaza por la de ese punto: antes, una direccion recuperada al volver
     contaba como escrita y el pin ya no la cambiaba. Los detalles (dpto.,
     piso) van en Referencia. Solo vale la respuesta mas reciente. */
  var consultaGeo = 0;
  function completarDesdeUbicacion(lat, lng, conDireccion, delPin) {
    var mia = ++consultaGeo;
    googleListo()
      .then(function () {
        return google.maps.importLibrary('geocoding');
      })
      .then(function (lib) {
        return new lib.Geocoder().geocode({ location: { lat: lat, lng: lng }, language: 'es', region: 'pe' });
      })
      .then(function (r) {
        var res = (r && r.results) || [];
        if (mia !== consultaGeo || !res.length || estado.destino !== 'lima') return;
        /* 27-oct: el mejor resultado es el de la puerta (direccion con numero);
           el primero a veces es un carril, un local o un codigo */
        function esTipo(x, t) {
          return (x.types || []).indexOf(t) !== -1;
        }
        function conComp(x, t) {
          return (x.address_components || []).some(function (c) {
            return c.types.indexOf(t) !== -1;
          });
        }
        var mejor =
          res.filter(function (x) { return esTipo(x, 'street_address') || esTipo(x, 'premise'); })[0] ||
          res.filter(function (x) { return conComp(x, 'route') && conComp(x, 'street_number'); })[0] ||
          res.filter(function (x) { return conComp(x, 'route') && !esTipo(x, 'route'); })[0] ||
          res.filter(function (x) { return conComp(x, 'route'); })[0];
        var comps = (mejor || res[0]).address_components || [];
        /* distrito de Lima o Callao que coincida con lo que devuelve Google */
        var elegido = distritoDeComponentes(
          [comps].concat(
            res.map(function (x) {
              return x.address_components || [];
            })
          )
        );
        if (elegido && f.dist.value !== elegido) {
          f.dist.value = elegido;
          limpiarError('dist');
        }
        if (conDireccion && (delPin || !f.dir.value.trim() || estado.dirAuto)) {
          var cc = mejor ? mejor.address_components : [];
          var calle = cc.filter(function (c) { return c.types.indexOf('route') !== -1; })[0];
          var num = cc.filter(function (c) { return c.types.indexOf('street_number') !== -1; })[0];
          if (calle) {
            f.dir.value = calle.long_name + (num ? ' ' + num.long_name : '');
            estado.dirAuto = true;
            if (estado.coords) estado.coords.texto = f.dir.value;
            limpiarError('dir');
          } else if (delPin) {
            /* sin calle en ese punto: no se deja la direccion de otro lugar */
            f.dir.value = '';
            estado.dirAuto = true;
            if (estado.coords) estado.coords.texto = '';
            f.notaDir.className = 'ep-co__nota';
            f.notaDir.textContent = 'Escribe la calle y el número de este punto.';
          }
        }
      })
      .catch(function () {
        /* sin Geocoding: el cliente elige el distrito y escribe la direccion */
      });
  }

  /* 27-oct: pin obligatorio en Lima. Si el cliente escribio la direccion sin
     marcar el pin, se busca con Google (calle, numero y distrito) y el mapa
     salta a ese punto para que lo confirme o lo mueva. Solo vale un resultado
     a nivel de calle, dentro de Lima y Callao y del distrito elegido.
     Devuelve 'ok', 'sin-resultado', 'sin-datos' o 'sin-google'. */
  var consultaUbicar = 0;
  function ubicarDireccion() {
    var u = porUbigeo[f.dist.value];
    var texto = f.dir.value.trim();
    if (estado.coords) return Promise.resolve('ok');
    if (estado.destino !== 'lima' || !u || texto.length < 5) return Promise.resolve('sin-datos');
    var mia = ++consultaUbicar;
    return googleListo()
      .then(function () {
        return google.maps.importLibrary('geocoding');
      })
      .then(function (lib) {
        return new lib.Geocoder().geocode({
          address: texto + ', ' + u.dist + ', ' + (u.dep === 'Callao' ? 'Callao' : 'Lima') + ', Perú',
          region: 'pe',
          componentRestrictions: { country: 'PE' },
          bounds: LIMA_BOUNDS
        });
      })
      .then(function (r) {
        /* mientras tanto el cliente movio el pin, eligio una sugerencia o cambio el texto */
        if (estado.coords) return 'ok';
        if (mia !== consultaUbicar || f.dir.value.trim() !== texto) return 'sin-resultado';
        var b = LIMA_BOUNDS;
        var bueno = ((r && r.results) || []).filter(function (x) {
          var g = x.geometry || {};
          if (!g.location || g.location_type === 'APPROXIMATE') return false;
          var lat = g.location.lat();
          var lng = g.location.lng();
          if (lat > b.north || lat < b.south || lng < b.west || lng > b.east) return false;
          var d = distritoDeComponentes([x.address_components || []]);
          return !d || d === f.dist.value;
        })[0];
        if (!bueno) return 'sin-resultado';
        var loc = bueno.geometry.location;
        estado.coords = { lat: loc.lat(), lng: loc.lng(), texto: f.dir.value, geocodificado: true };
        mostrarMapa(loc.lat(), loc.lng(), 17);
        limpiarError('dir');
        f.notaDir.className = 'ep-co__nota ep-co__nota--ok';
        f.notaDir.textContent = '✓ Ubicamos tu dirección. Si el pin no está en tu puerta, mueve el mapa.';
        return 'ok';
      })
      .catch(function () {
        return 'sin-google';
      });
  }

  function pedirPin() {
    error('dir', 'No encontramos tu dirección en el mapa. Mueve el mapa hasta tu puerta o usa "Usar mi ubicación".');
    if (f.mapa && !f.mapa.hidden) f.mapa.scrollIntoView({ block: 'center', behavior: 'smooth' });
    else f.dir.focus();
  }

  function borrarCoordenadas() {
    estado.coords = null;
    if (f.notaDir) {
      f.notaDir.textContent = '';
      f.notaDir.className = 'ep-co__nota';
    }
  }

  /* ------------------------------------------------------------------ */
  /* Abrir / cerrar                                                     */
  /* ------------------------------------------------------------------ */
  function abrir() {
    crearDialogo();
    f.errEnvio.textContent = '';
    f.btn.removeAttribute('aria-busy');
    f.btn.textContent = 'Ir a pagar';
    if (f.directoNota) f.directoNota.hidden = true;
    try {
      f.dir.value = f.dir.value || sessionStorage.getItem(SS_DIR) || '';
      f.ref.value = f.ref.value || sessionStorage.getItem(SS_REF) || '';
    } catch (e) {
      /* sessionStorage bloqueado: no pasa nada */
    }
    /* 26-oct: siempre empieza en la primera pantalla. Lo ya elegido queda
       marcado y, al tocarlo otra vez, avanza con los datos cargados. */
    mostrarPantalla('entrega');
    if (!dlg.open) dlg.showModal();
    cargarCatalogo().catch(function () {});

    /* Si el cliente ya paso por aqui (volvio del pago), se precarga desde
       los atributos del carrito, no desde el navegador, sin saltar pasos. */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        estado.carrito = cart;
        pintarResumen(cart);
        pintarTotales(!f.btn.hidden);
        /* 27-oct: el stock de las tiendas se pide ya, asi la lista de recojo sale al instante */
        if (lineasConEnvio(cart).length) pedirTiendas(cart).catch(function () {});
        var a = cart.attributes || {};
        if (!f.doc.value && a.dni) {
          f.tipo.value = a.tipo_documento === DOCS.CE.codigo ? 'CE' : 'DNI';
          f.doc.maxLength = DOCS[f.tipo.value].largo;
          f.doc.value = a.dni;
        }
        if (a['ClusterCart-solicitar_factura'] === 'true' && !f.ruc.value) {
          f.factura.checked = true;
          f.facturaBox.hidden = false;
          f.ruc.value = a.ruc || '';
          f.razon.value = a.razon_social || '';
        }
        if (!estado.entrega && !estado.destino && a.location_ubigeo && a._ep_entrega !== 'recojo') {
          return cargarCatalogo().then(function () {
            var u = porUbigeo[a.location_ubigeo];
            if (!u || !esLimaCallao(u)) return;
            /* el cliente pudo elegir algo mientras cargaba: no se le cambia */
            if (estado.entrega || estado.destino) return;
            estado.entrega = 'delivery';
            estado.destino = 'lima';
            dlg.querySelector('input[name="entrega"][value="delivery"]').checked = true;
            dlg.querySelector('input[name="destino"][value="lima"]').checked = true;
            if (f.dist.options.length <= 1) llenarDistritosLima();
            if (!f.dist.value) f.dist.value = a.location_ubigeo;
            /* el pin que dejo la vez anterior. No cuenta como ajuste del cliente:
               si cambia el distrito o escribe otra direccion, se borra. */
            var lat = parseFloat(a['ClusterCart-latitude']);
            var lng = parseFloat(a['ClusterCart-longitude']);
            if (!estado.coords && isFinite(lat) && isFinite(lng)) {
              estado.coords = { lat: lat, lng: lng, texto: f.dir.value, guardado: true };
            }
          });
        }
      })
      .catch(function () {});

    setTimeout(function () {
      if (CFG.pedirDocumento && !f.doc.value && estado.pantalla === 'entrega' && window.matchMedia('(min-width: 750px)').matches) f.doc.focus();
      else f.titulo.focus({ preventScroll: true });
    }, 50);
  }

  /* Resumen del pedido en una linea y el sello "Gratis" si el carrito llega al monto */
  function pintarResumen(cart) {
    var linea = dlg.querySelector('[data-ep-resumen]');
    var sello = dlg.querySelector('[data-ep-gratis]');
    if (!cart || !cart.item_count) {
      linea.hidden = true;
      sello.hidden = true;
      return;
    }
    linea.textContent = cart.item_count + (cart.item_count === 1 ? ' producto' : ' productos') + ' · ' + soles(cart.total_price);
    linea.hidden = false;
    var umbral = Number(CFG.umbral) * 100;
    sello.hidden = !(umbral > 0 && cart.total_price >= umbral);
  }

  function cerrar() {
    if (dlg && dlg.open) dlg.close();
  }

  /* ------------------------------------------------------------------ */
  /* Validar y enviar                                                   */
  /* ------------------------------------------------------------------ */
  /* Documento y factura (si el ajuste los pide) */
  function revisarDocumento(mal) {
    if (!CFG.pedirDocumento) return;
    var doc = DOCS[f.tipo.value];
    if (!new RegExp('^\\d{' + doc.minimo + ',' + doc.largo + '}$').test(f.doc.value)) {
      var cifras = doc.minimo === doc.largo ? doc.largo + ' dígitos' : 'entre ' + doc.minimo + ' y ' + doc.largo + ' dígitos';
      mal('doc', f.doc.value ? 'El ' + doc.nombre + ' debe tener ' + cifras + '.' : 'Escribe tu ' + doc.nombre + ' para continuar.');
    }
    if (f.factura.checked) {
      if (!rucValido(f.ruc.value)) mal('ruc', 'Revisa el RUC: son 11 dígitos y debe ser un RUC válido.');
      if (f.razon.value.trim().length < 3) mal('razon', 'Escribe la razón social para tu factura.');
    }
  }

  /* Antes de elegir la entrega: si el documento falta o esta mal, se marca y no avanza */
  function documentoListo() {
    var primero = null;
    revisarDocumento(function (campo, texto) {
      error(campo, texto);
      if (!primero) primero = f[campo];
    });
    if (primero) {
      if (estado.pantalla !== 'entrega') mostrarPantalla('entrega');
      primero.focus();
      if (primero.scrollIntoView) primero.scrollIntoView({ block: 'center' });
    }
    return !primero;
  }

  function validar() {
    var primero = null;
    function mal(campo, texto) {
      error(campo, texto);
      if (!primero) primero = f[campo];
    }
    revisarDocumento(mal);
    if (!estado.entrega) {
      error('entrega', 'Elige envío a domicilio o recojo en tienda.');
      if (!primero) primero = f.entrega[0];
    } else if (estado.entrega === 'recojo') {
      /* la tienda se toca en la lista; el boton solo aparece si no cargo el
         stock, y entonces se elige en el checkout */
    } else if (!estado.destino) {
      error('destino', 'Elige Lima y Callao o Provincia.');
      if (!primero) primero = f.destino[0];
    } else if (estado.destino === 'lima') {
      if (!porUbigeo[f.dist.value]) mal('dist', 'Elige el distrito.');
      var dir = f.dir.value.trim();
      if (dir.length < 5 || !(/\d/.test(dir) || /\bs\s*\/?\s*n\b/i.test(dir))) {
        mal('dir', 'Agrega el número (o S/N si no tiene).');
      }
    }
    if (primero) {
      var pant = primero.closest ? primero.closest('[data-ep-pantalla]') : null;
      if (pant && pant.hidden) mostrarPantalla(pant.getAttribute('data-ep-pantalla'));
      if (primero.focus) primero.focus();
    }
    return !primero;
  }

  function enviar(e) {
    e.preventDefault();
    f.errEnvio.textContent = '';
    if (!validar()) return;
    if (estado.entrega === 'recojo') return irDirecto('recojo');
    if (estado.destino === 'provincia') return irDirecto('provincia');

    /* 27-oct: pin obligatorio en Lima. Sin pin se intenta ubicar la direccion;
       si Google no la encuentra, se pide mover el mapa. Si Google Maps no
       esta disponible (no hay mapa que mover), se sigue sin coordenadas. */
    if (!estado.coords && !estado.sinMapa) {
      f.btn.setAttribute('aria-busy', 'true');
      f.btn.textContent = 'Ubicando tu dirección…';
      ubicarDireccion().then(function (r) {
        f.btn.removeAttribute('aria-busy');
        f.btn.textContent = 'Ir a pagar';
        if (r === 'sin-google') estado.sinMapa = true;
        if (estado.coords || estado.sinMapa) return enviar(e);
        pedirPin();
      });
      return;
    }

    var u = porUbigeo[f.dist.value];
    var doc = DOCS[f.tipo.value];
    var factura = f.factura.checked;
    var ruc = factura ? f.ruc.value : '';
    var c = estado.coords;

    /* Mismo contrato que el modal de Cluster. Un valor vacio BORRA el
       atributo, asi no quedan datos de una compra o un intento anterior. */
    var attributes = {
      'ClusterCart-optimized': 'true',
      'ClusterCart-tipo_documento': doc.codigo,
      'ClusterCart-dni': f.doc.value,
      tipo_documento: doc.codigo,
      dni: f.doc.value,
      'ClusterCart-solicitar_factura': factura ? 'true' : '',
      'ClusterCart-ruc': ruc,
      ruc: ruc,
      /* 27-oct: Cluster tambien manda el RUC como checkout[note_attributes][RUC]
         y llega al pedido como "RUC", en mayusculas */
      RUC: ruc,
      razon_social: factura ? f.razon.value.trim() : '',
      'ClusterCart-latitude': c ? String(c.lat) : '',
      'ClusterCart-longitude': c ? String(c.lng) : '',
      location_ubigeo: u.ubigeo,
      location_departamento: u.dep,
      location_provincia: u.prov,
      location_distrito: u.dist,
      zipcode: '',
      _ep_checkout: 'v1-lima',
      _ep_destino: 'lima',
      _ep_tienda: '', /* borra la tienda de un intento de recojo anterior */
      _ep_entrega: 'delivery',
      _ep_pin: c ? (c.gps ? 'gps' : c.ajustado ? 'ajustado' : c.guardado ? 'guardado' : c.geocodificado ? 'geocodificado' : 'google') : ''
    };
    if (!CFG.pedirDocumento) {
      /* El documento lo pide el checkout ("Informacion de facturacion", mismos
         atributos dni / tipo_documento): aqui no se escribe ni se borra, para
         no pisar lo que el cliente ponga ahi. */
      ['ClusterCart-tipo_documento', 'ClusterCart-dni', 'tipo_documento', 'dni', 'ClusterCart-solicitar_factura', 'ClusterCart-ruc', 'ruc', 'RUC', 'razon_social'].forEach(function (k) {
        delete attributes[k];
      });
    }

    f.btn.setAttribute('aria-busy', 'true');
    f.btn.textContent = 'Guardando tus datos…';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        /* Comprobar que de verdad quedo escrito antes de ir al pago */
        var a = cart.attributes || {};
        if ((CFG.pedirDocumento && a.dni !== f.doc.value) || a.location_ubigeo !== u.ubigeo) throw new Error('atributos no guardados');
        return preferirEntrega(cart, 'SHIPPING');
      })
      .then(function () {
        try {
          sessionStorage.setItem(SS_DIR, f.dir.value.trim());
          sessionStorage.setItem(SS_REF, f.ref.value.trim());
        } catch (e2) {
          /* sin sessionStorage: no pasa nada */
        }
        var p = new URLSearchParams();
        p.set('checkout[shipping_address][country]', 'Peru');
        if (CFG.pedirDocumento) p.set('checkout[shipping_address][company]', factura ? ruc : f.doc.value);
        p.set('checkout[shipping_address][address1]', f.dir.value.trim());
        /* 27-oct: siempre, aunque este vacia, para que el checkout no deje la
           referencia de un intento anterior */
        p.set('checkout[shipping_address][address2]', f.ref.value.trim());
        p.set('checkout[shipping_address][city]', u.dist);
        var region = codigoRegion(u.dep, u.prov);
        if (region) p.set('checkout[shipping_address][province]', region);
        p.set('checkout[shipping_address][zip]', u.ubigeo);
        f.btn.textContent = 'Yendo al pago…';
        window.location.href = '/checkout?' + p.toString();
      })
      .catch(function () {
        /* No se va al pago sin los datos: asi no salen pedidos incompletos */
        f.btn.removeAttribute('aria-busy');
        f.btn.textContent = 'Ir a pagar';
        f.errEnvio.textContent = 'No pudimos guardar tus datos. Revisa tu conexión e inténtalo otra vez.';
      });
  }

  /* 23-oct: le indica al checkout que metodo de entrega abrir (envio o retiro).
     Sin esto, Shopify recuerda el ultimo que el cliente marco en el checkout
     de ese carrito: quien probo "Recojo" y luego eligio Provincia llegaba al
     pago en recojo. Usa la API de Storefront sin token, solo sobre el carrito
     del cliente. Si falla o tarda mas de 6 s, se sigue al pago igual (con datos
     moviles lentos 2,5 s no alcanzaba y el recojo abria en envio). */
  /* Devuelve 'ok' si Shopify confirmo la preferencia, o 'fallo' (error, respuesta
     con errores o mas de 6 s). Si falla, reintenta una vez. 27-oct: en recojo,
     tiendaId (id de la ubicacion) hace que el checkout abra con esa tienda. */
  function preferirEntrega(cart, metodo, tiendaId) {
    if (!cart || !cart.token) return Promise.resolve('fallo');
    function intento() {
      return fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          query:
            'mutation EpEntrega($id: ID!, $b: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { userErrors { message } } }',
          variables: {
            id: 'gid://shopify/Cart/' + cart.token,
            b: {
              countryCode: 'PE',
              preferences: { delivery: tiendaId ? { deliveryMethod: [metodo], pickupHandle: [tiendaId] } : { deliveryMethod: [metodo] } }
            }
          }
        })
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (d) {
          var res = d && d.data && d.data.cartBuyerIdentityUpdate;
          return res && !(res.userErrors || []).length ? 'ok' : 'fallo';
        })
        .catch(function () {
          return 'fallo';
        });
    }
    var pedido = intento().then(function (r) {
      return r === 'ok' ? r : intento();
    });
    var espera = new Promise(function (ok) {
      setTimeout(function () {
        ok('fallo');
      }, 6000);
    });
    return Promise.race([pedido, espera]);
  }

  /* Salidas directas al pago: provincia (la direccion se llena en el checkout)
     y recojo en tienda (con la tienda elegida en la lista). Borra los datos de
     envio de un intento anterior para que el pedido no lleve una direccion que
     no corresponde, deja el documento si se pidio y marca el camino elegido. */
  function irDirecto(tipo) {
    var doc = DOCS[f.tipo.value];
    var factura = f.factura.checked;
    var recojo = tipo === 'recojo';
    var tienda = recojo ? estado.tienda : null;
    var attributes = {
      'ClusterCart-optimized': 'true',
      'ClusterCart-latitude': '',
      'ClusterCart-longitude': '',
      location_ubigeo: '',
      location_departamento: '',
      location_provincia: '',
      location_distrito: '',
      zipcode: '',
      _ep_checkout: 'v1-' + tipo,
      _ep_destino: recojo ? 'lima' : 'provincia',
      _ep_tienda: tienda ? tienda.nombre : '',
      _ep_entrega: recojo ? 'recojo' : 'delivery',
      _ep_pin: ''
    };
    if (CFG.pedirDocumento) {
      attributes['ClusterCart-tipo_documento'] = doc.codigo;
      attributes['ClusterCart-dni'] = f.doc.value;
      attributes.tipo_documento = doc.codigo;
      attributes.dni = f.doc.value;
      attributes['ClusterCart-solicitar_factura'] = factura ? 'true' : '';
      attributes['ClusterCart-ruc'] = factura ? f.ruc.value : '';
      attributes.ruc = factura ? f.ruc.value : '';
      attributes.RUC = factura ? f.ruc.value : '';
      attributes.razon_social = factura ? f.razon.value.trim() : '';
    }
    f.errEnvio.textContent = '';
    f.btn.setAttribute('aria-busy', 'true');
    f.btn.textContent = 'Yendo al pago…';
    f.directoNota.hidden = false;
    f.directoNota.textContent = 'Yendo al pago…';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var ga = cart.attributes || {};
        if (ga._ep_checkout !== 'v1-' + tipo || (CFG.pedirDocumento && ga.dni !== f.doc.value)) throw new Error('atributos no guardados');
        return preferirEntrega(cart, recojo ? 'PICK_UP' : 'SHIPPING', tienda ? tienda.id : '');
      })
      .then(function (aviso) {
        /* 27-oct: como Cluster, el DNI (o el RUC con factura) va tambien en
           "Empresa" de la direccion de envio. En recojo no hay direccion de
           envio en el pedido, asi que se deja el checkout sin parametros. */
        var p = new URLSearchParams({ 'checkout[shipping_address][country]': 'Peru' });
        if (CFG.pedirDocumento) p.set('checkout[shipping_address][company]', factura ? f.ruc.value : f.doc.value);
        var url = recojo ? '/checkout' : '/checkout?' + p.toString();
        /* si Shopify no recibio la preferencia de recojo, se avisa al cliente
           que elija la tienda en el pago (el checkout puede abrir en envio) */
        if (recojo && aviso !== 'ok') {
          f.directoNota.textContent = 'En el pago elige "Recojo en tienda" y ' + (tienda ? tienda.nombre : 'tu tienda') + '.';
          setTimeout(function () {
            window.location.href = url;
          }, 2500);
          return;
        }
        window.location.href = url;
      })
      .catch(function () {
        f.btn.removeAttribute('aria-busy');
        f.btn.textContent = 'Ir a pagar';
        f.btn.hidden = false;
        f.directoNota.hidden = true;
        f.errEnvio.textContent = 'No pudimos continuar. Revisa tu conexión e inténtalo otra vez.';
      });
  }

  /* ------------------------------------------------------------------ */
  /* Disparador: cualquier [data-ep-checkout-abrir]                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ep-checkout-abrir]');
    if (!btn) return;
    e.preventDefault();
    /* 23-oct: en celular la hoja sube sobre el carrito (estilo Sifrah); en PC,
       como antes, se cierra el carrito y el formulario abre centrado. */
    if (window.matchMedia('(min-width: 750px)').matches) {
      var cajon = document.querySelector('cart-drawer-component');
      if (cajon && typeof cajon.close === 'function') cajon.close();
    }
    /* deja que el carrito desplegable termine de cerrarse */
    setTimeout(abrir, 60);
  });
})();
